import { render, staticRenderFns } from "./LevelsInput.vue?vue&type=template&id=321ff5ca&scoped=true"
import script from "./LevelsInput.vue?vue&type=script&lang=ts"
export * from "./LevelsInput.vue?vue&type=script&lang=ts"
import style0 from "./LevelsInput.vue?vue&type=style&index=0&id=321ff5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ff5ca",
  null
  
)

export default component.exports